<app-header></app-header>

<div class="container-fluid p-5 mt-5">
  <mat-radio-group
    style="font-size: 1em; font-weight: bold; padding: 2rem"
    [(ngModel)]="view"
    (ngModelChange)="onFirstGroupChange($event.value)"
    aria-label="Select an option"
  >
    <mat-radio-button style="margin: 10px" checked color="primary" value="new"
      >New Lending</mat-radio-button
    >
    <mat-radio-button color="primary" style="margin: 10px" value="existing"
      >Lend from Existing Claim</mat-radio-button
    >
  </mat-radio-group>

  <div *ngIf="view == 'new'">
    <div class="container">
      <form [formGroup]="claimForm">
        <h3 style="text-align: center;padding:20px">EasyFin Lending</h3>
        <div class="form-container">
          <h5 class="MSB24">Claim Details</h5>
          <div class="form-row">
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Claim number</mat-label>
                <input
                  matInput
                  formControlName="claimNumber"
                  placeholder="Enter Claim Number"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('claimNumber')?.hasError('required')"
                >
                  Claim Number is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Date of Admission</mat-label>
                <input
                  matInput
                  [matDatepicker]="doaPicker"
                  formControlName="dateOfAdmission"
                  placeholder="Select Date of Birth"
                  required
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="doaPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #doaPicker></mat-datepicker>
                <mat-error *ngIf="claimForm.get('dateOfAdmission')?.hasError('required')">
                  Date of Admission is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Date of Discharge</mat-label>
                <input
                  matInput
                  [matDatepicker]="dodPicker"
                  [min]="claimForm.controls['dateOfAdmission'].value"
                  formControlName="dateOfDischarge"
                  placeholder="Select Date of Birth"
                  required
                  [disabled]="checkDoD()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="dodPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #dodPicker></mat-datepicker>
                <mat-error *ngIf="claimForm.get('dateOfDischarge')?.hasError('required')">
                  Date of Discharge is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Claim Amount</mat-label>
                <input
                  matInput
                  formControlName="claimedAmount"
                  placeholder="Enter Claim Amount"  (keypress)="numberOnly($event)"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('claimedAmount')?.hasError('required')"
                >
                  Claim Amount is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Approved Amount</mat-label>
                <input
                  matInput
                  formControlName="approvedAmount"
                  placeholder="Enter Approved Amount"  (keypress)="numberOnly($event)"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('approvedAmount')?.hasError('required')"
                >
                Approved Amount is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>TPA Name</mat-label>
                <mat-select formControlName="tpaName" required>
                  <mat-option value="item.displayName" *ngFor="let item of tpaList">{{item.displayName}}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="claimForm.get('tpaName')?.hasError('required')"
                >
                TPA name is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <h5 class="MSB24">Personal Information</h5>
          <div class="form-row">
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>First Name</mat-label>
                <input
                  matInput
                  formControlName="firstName"
                  placeholder="Enter First Name"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('firstName')?.hasError('required')"
                >
                  First Name is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Middle Name</mat-label>
                <input
                  matInput
                  formControlName="middleName"
                  placeholder="Enter Middle Name"
                />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Last Name</mat-label>
                <input
                  matInput
                  formControlName="lastName"
                  placeholder="Enter Last Name"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('lastName')?.hasError('required')"
                >
                  Last Name is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Mobile Number</mat-label>
                <input
                  matInput
                  formControlName="mobileNumber"
                  placeholder="Enter Mobile Number" maxlength="10"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('mobileNumber')?.hasError('required')"
                >
                  Mobile Number is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  formControlName="email"
                  placeholder="Enter Email"
                  required
                />
                <mat-error *ngIf="claimForm.get('email')?.hasError('required')">
                  Email is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Gender</mat-label>
                <mat-select formControlName="gender" required>
                  <mat-option value="male">Male</mat-option>
                  <mat-option value="female">Female</mat-option>
                  <mat-option value="other">Other</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Date of Birth</mat-label>
                <input
                  matInput
                  [matDatepicker]="dobPicker"
                  formControlName="dob"
                  placeholder="Select Date of Birth"
                  required
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="dobPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #dobPicker></mat-datepicker>
                <mat-error *ngIf="claimForm.get('dob')?.hasError('required')">
                  Date of Birth is required
                </mat-error>
              </mat-form-field>
            </div>
            <!-- <div class="col-2"></div> -->
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>PAN</mat-label>
                <input
                  matInput
                  formControlName="panNumber"
                  placeholder="Enter PAN" maxlength="10"
                  required
                />
                <mat-error *ngIf="claimForm.get('panNumber')?.hasError('required')">
                  PAN is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <h5 class="MSB24">Address Information</h5>
          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field full-width">
              <mat-label>Address Line 1</mat-label>
              <input
                matInput
                formControlName="addressLine1"
                placeholder="Enter Address Line 1"
                required
              />
              <mat-error
                *ngIf="claimForm.get('addressLine1')?.hasError('required')"
              >
                Address Line 1 is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field full-width">
              <mat-label>Address Line 2</mat-label>
              <input
                matInput
                formControlName="addressLine2"
                placeholder="Enter Address Line 2"
              />
            </mat-form-field>
          </div>
          <div class="form-row">
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Pincode</mat-label>
                <input
                  matInput
                  formControlName="pincode"
                  placeholder="Enter Pincode"  (keypress)="numberOnly($event)" maxlength="6"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('pincode')?.hasError('pincode')"
                >
                  Pincode is required
                </mat-error>
              </mat-form-field>
            </div>
           
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>State</mat-label>
                <mat-select  formControlName="state" required  (selectionChange)="onStateSelectionChange($event)">
                    <mat-option [value]='state' *ngFor="let state of states">{{state.name}}</mat-option>
                </mat-select>                
                <mat-error *ngIf="claimForm.get('state')?.hasError('state')">
                  State is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>City</mat-label>
                <mat-select  formControlName="city" required >
                  <mat-option [value]='city.name' *ngFor="let city of cities">{{city.name}}</mat-option>
              </mat-select> 
                <mat-error *ngIf="claimForm.get('city')?.hasError('city')">
                  City is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <h5 class="MSB24">Employment Information</h5>
          <div class="form-row">
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Employment Type</mat-label>
                <mat-select formControlName="employmentType" required>
                  <mat-option value="salaried">Salaried</mat-option>
                  <mat-option value="self-employed">Self-employed</mat-option>
                  <mat-option value="unemployed">Unemployed</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Monthly Income</mat-label>
                <input
                  matInput
                  formControlName="monthlyIncome"
                  placeholder="Enter Monthly Income"  (keypress)="numberOnly($event)"
                  required
                />
                <mat-error
                  *ngIf="
                    claimForm.get('monthlyIncome')?.hasError('monthlyIncome')
                  "
                >
                  Monthly Income is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Office Pincode</mat-label>
                <input
                  matInput
                  formControlName="officePincode"
                  placeholder="Enter Office Pincode"  (keypress)="numberOnly($event)" maxlength="6"
                  required
                />
                <mat-error
                  *ngIf="
                    claimForm.get('officePincode')?.hasError('officePincode')
                  "
                >
                  Office Pincode is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-5">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Order Amount</mat-label>
                <input
                  matInput
                  formControlName="orderAmount"
                  placeholder="Enter Order Amount"  (keypress)="numberOnly($event)"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('orderAmount')?.hasError('orderAmount')"
                >
                  Order Amount is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <h5 class="MSB24">Patient Information</h5>
          <div class="form-row">
            <mat-label>Patient Type</mat-label>
            <mat-radio-group
              formControlName="patientType"
              class="radio-group"
              required (change)="onRadioChange($event)"
            >
              &nbsp;&nbsp;
              <mat-radio-button value="self">Self</mat-radio-button>&nbsp;&nbsp;
              <mat-radio-button value="others"
                >Others</mat-radio-button
              > </mat-radio-group
            >&nbsp;&nbsp;
            <mat-error
              *ngIf="claimForm.get('patientType')?.hasError('required')"
            >
              Please select a Patient Type
            </mat-error>
          </div>
          <div class="form-row">
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Patient First Name</mat-label>
                <input
                  matInput
                  formControlName="patientFirstName"
                  placeholder="Enter First Name"
                  required
                />
                <mat-error
                  *ngIf="
                    claimForm.get('patientFirstName')?.hasError('required')
                  "
                >
                  Patient First Name is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Patient Last Name</mat-label>
                <input
                  matInput
                  formControlName="patientLastName"
                  placeholder="Enter Last Name"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('patientLastName')?.hasError('required')"
                >
                  Patient Last Name is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4" *ngIf="relationshipType == 'others'">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Relationship</mat-label>
                <mat-select formControlName="relationshipWithPatient" >
                  <mat-option value="wife">Wife</mat-option>
                  <mat-option value="grandson">Grandson</mat-option>
                  <mat-option value="granddaughter">Granddaughter</mat-option>
                  <mat-option value="grandfather">Grandfather</mat-option>
                  <mat-option value="grandmother">Grandmother</mat-option>
                  <mat-option value="father-in-law">Father-in-Law</mat-option>
                  <mat-option value="sister-in-law">Sister-in-Law</mat-option>
                  <mat-option value="uncle">Uncle</mat-option>
                  <mat-option value="aunt">Aunt</mat-option>
                  <mat-option value="nephew">Nephew</mat-option>
                  <mat-option value="niece">Niece</mat-option>
                  <mat-option value="mother-in-law">Mother-in-Law</mat-option>
                  <mat-option value="son">Son</mat-option>
                  <mat-option value="daughter">Daughter</mat-option>
                  <mat-option value="mother">Mother</mat-option>
                  <mat-option value="father">Father</mat-option>
                  <mat-option value="sister">Sister</mat-option>
                  <mat-option value="daughter-in-law">Daughter-in-Law</mat-option>
                  <mat-option value="brother">Brother</mat-option>
                  <mat-option value="cousin">Cousin</mat-option>
                </mat-select>
              </mat-form-field>
              </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Patient Mobile</mat-label>
                <input
                  matInput
                  formControlName="patientMobile"
                  placeholder="Enter Mobile Number"  (keypress)="numberOnly($event)" maxlength="10"
                  type="tel"
                  required
                />
                <mat-error
                  *ngIf="claimForm.get('patientMobile')?.hasError('required')"
                >
                  Patient Mobile is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Treatment Type</mat-label>
                <mat-select formControlName="treatmentType" required   (selectionChange)="onSelectionChange($event)">
                  <mat-option value="Critical Illness"
                    >Critical Illness</mat-option
                  >
                  <mat-option value="Non Critical Illness"
                    >Non Critical Illness</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Treatment Sub Type</mat-label>
                <mat-select formControlName="treatmentSubtype" required>
                  <mat-option value="item.value" *ngFor="let item of treatmentSubtypeOptions"
                    >{{item.name}}</mat-option
                  >
                 
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <!-- Radio buttons for Patient Type -->
          <div class="col-4">
            <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="checkValidity()"
            (click)="submitForm()"
          >
            Submit
          </button>
          </div>
          
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="view == 'existing'">
    <div class="row ml-3 mr-3 mt-3">
      <div class="example-form col-3 pl-0">
        <mat-label class="ml-2"> &nbsp; </mat-label>
        <mat-form-field
          class="example-full-width greenBorder MSB16"
          floatLabel="never"
        >
          <input
            type="text"
            placeholder="Search by Claim ID/ Member ID"
            matInput
            (keyup)="applyFilter($event)"
          />
        </mat-form-field>
      </div>
      <div class="example-form col-3 offset-2">
        <mat-label class="ml-2 MSB16"> TPA </mat-label>
        <mat-form-field class="greenBorder" style="width: 100%">
          <mat-select
            class="MM16"
            name="tpa"
            [(value)]="selectedTPA"
            (valueChange)="getClaimDetailsList('0', '10', this.selected)"
          >
            <mat-option value=""> View All </mat-option>
            <mat-option
              *ngFor="let tpa of tpaList"
              [value]="tpa.id"
              [matTooltip]="tpa.displayName"
            >
              {{ tpa.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="example-form col-2 pr-0">
        <mat-label class="ml-2 MSB16"> Status </mat-label>
        <mat-form-field class="greenBorder" style="width: 100%">
          <mat-select
            class="MM16"
            name="status"
            [(value)]="selectedStatus"
            (valueChange)="getClaimDetailsList('0', '10', this.selected)"
          >
            <mat-option value=""> View All </mat-option>
            <mat-option
              *ngFor="let status of statusList"
              [value]="status"
              [matTooltip]="status"
            >
              {{ status?.replaceAll("_", " ") | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="example-form col-2 pr-0">
        <mat-label class="ml-2 MSB16"> Claim Type </mat-label>
        <mat-form-field class="greenBorder" style="width: 100%">
          <mat-select
            class="MM16"
            name="status"
            [(value)]="selectedType"
            (valueChange)="applyFilterType($event)"
          >
            <mat-option value=""> View All </mat-option>
            <mat-option value="Group"> Group </mat-option>
            <mat-option value="Retail"> Retail </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row m-4">
      <table
        mat-table
        *ngIf="dataSource.filteredData.length != 0"
        [dataSource]="dataSource"
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="claimId">
          <th mat-header-cell *matHeaderCellDef>
            <ng-template [ngIf]="this.selected === 'SAVED_CLAIMS'">
              Reference Id
            </ng-template>
            <ng-template [ngIf]="this.selected != 'SAVED_CLAIMS'">
              Claim Id
            </ng-template>
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element?.tpaClaimId; else alternateClaim">
              {{ element?.tpaClaimId }}
            </span>
            <ng-template #alternateClaim>
              {{ element?.alternateClaim }}
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="memberId">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            Member Id
          </th>
          <td mat-cell *matCellDef="let element">{{ element.memberId }}</td>
        </ng-container>

        <ng-container matColumnDef="memberName">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            Member Name
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            style="max-width: 15vw; overflow: overlay"
          >
            {{ element.memberName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            Claim Type
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            style="max-width: 15vw; overflow: overlay"
          >
            {{ element.type }}
          </td>
        </ng-container>

        <ng-container matColumnDef="patientId">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            Patient Id
          </th>
          <td mat-cell *matCellDef="let element">{{ element.patientId }}</td>
        </ng-container>

        <ng-container matColumnDef="payer">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            Payer
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            style="max-width: 15vw; overflow: overlay"
          >
            {{ element.insurerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="employeeId">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            Employee Id
          </th>
          <td mat-cell *matCellDef="let element">{{ element.employeeId }}</td>
        </ng-container>
        <ng-container matColumnDef="TPAName">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            TPA Name
          </th>
          <td mat-cell *matCellDef="let element">{{ element.tpaName }}</td>
        </ng-container>
        <ng-container matColumnDef="claimStatus">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            Claim Status
          </th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="this.selected != 'SAVED_CLAIMS'">
              <ng-template
                [ngIf]="
                  !element?.claimSubReason ||
                  element?.claimSubReason == 'Rejection Review' ||
                  element?.claimSubReason == 'Insurer Approval Received' ||
                  element?.claimSubReason == 'Insurer Rejected'
                "
              >
                {{ element?.claimStatus?.replaceAll("_", " ") | titlecase }}
              </ng-template>
              <ng-template [ngIf]="element?.claimSubReason === 'Cancel Claim'">
                Claim Cancelled by
                <ng-template [ngIf]="element?.claimRejectedBy === 'PROVIDER'">
                  Provider
                </ng-template>
                <ng-template [ngIf]="!element?.claimRejectedBy">
                  TPA
                </ng-template>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="this.selected === 'SAVED_CLAIMS'">
              Saved Claim
            </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="tat">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            TAT
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.tat.hours }}:{{ element.tat.minutes }}
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 15px">
            Action
          </th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-raised-button
              color="accent"
              
              *ngIf="
                element.claimStatus == 'CLAIM_REJECTED' &&
                element?.isLendingEligibile
              "
              (click)="sendForFinovaIngestion(element.alternateClaim)" style="background-color:#0c3f6f;margin-right: 15px;"
            >
              Apply for Lendng
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        class="mat-elevation-z8 full-width-field"
        [length]="resultsLength"
        [pageSizeOptions]="[10, 25, 50, 100]"
        [pageSize]="pageSize"
        (page)="onPageChange($event)"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
    <div
      class="row m-4"
      style="background-color: #8aa9ff15; min-height: 415px"
      *ngIf="dataSource.filteredData.length === 0"
    >
      <div class="col-4 offset-md-4 mt-5 text-center">
        <img src="assets/icons/Shared/Group 585.png" /> <br /><br />
        <h4>
          You have No
          <ng-template [ngIf]="selected === 'ON_GOING'">
            Ongoing Queries
          </ng-template>
          <ng-template [ngIf]="selected != 'ON_GOING'">
            {{ selected?.replaceAll("_", " ") | titlecase }}!
          </ng-template>
        </h4>
        <p>
          Try adjusting your search or filter <br />
          to find what you’re looking for
        </p>
      </div>
    </div>
  </div>
</div>
<!-- <mat-form-field class="full-width-field">
  <mat-label>User Name</mat-label>
  <input matInput formControlName="userName" placeholder="User Name">
</mat-form-field> -->
